import React from 'react'
export const plans = [
  {
    title: "Discovery",
    plan_type: 'subscription',
    title_plus: 'Discovery',
    subtitle: "For new creators",
    identifier: 'free_trial_ai',
    description:
      "25 credits a month. Up to 5 images.",
    price: 0,
    priceMonthly: 0,
    annualPeriod: "",
    monthlyPeriod: "Free",
    monthlyPlusPeriod: "Free",
    priceAnnual: 0,
    buttonText: "Start Free Trial",
    buttonLink: "https://app.all3d.ai/register",
    discount: "",
    discount_monthly: "",
    features: [
      "25 Monthly Credits",
      "Up to 5 Images (5 credits ea.)",
      "3 User Licenses",
      "Standard Generation Speed",
    ],
    monthly_features: [
      "25 Monthly Credits",
      "Up to 5 Images (5 credits ea.)",
      "3 User Licenses",
      "Standard Generation Speed",
    ],
    plus_features: [
      "Magic erase & resize",
      "Replace items & color correction",
      "Upload inspiration & props",
    ],
    get_more_toggle: false,
    package_type: "Discovery",
    plan_name: "free_trial_ai",
    plan_plus_name: "free_trial_ai",
    annual_plan_name: "annual_free_trial_ai",
    credits_details: <span>Your plan includes <b>100 credits</b>, redeemable at <b>5 credits per image</b> or <b>45 credits per video</b>.</span>,
    annual_credits_details: <span>Your plan includes <b>100 credits</b>, redeemable at <b>5 credits per image</b> or <b>45 credits per video</b>.</span>,
    feature_table: [
      { name: "Monthly Credits", value: "100" },
      { name: "Images (5 credits ea.)", value: "Up to 20" },
      { name: "User Licenses", value: "3" },
      { name: "Max Concurrent Image Generations", value: "1" },
      { name: "Max Concurrent Video Generations", value: "1" },
    ],
    advanced_feature_table: [
      { name: "Magic Erase & Resize", included: true },
      { name: "Replace Items & Color Correction", included: true },
      { name: "Texture Transfer (Logos/Small Items)", included: false },
      { name: "Product Silos & 3D CGI Images", included: false },
      { name: "Upload Inspiration & Props", included: true },
      { name: "Bulk Uploads", included: false },
      { name: "Brand Guidelines Support", included: false },
      { name: "Review Gallery (Quality Management)", included: false },
      { name: "Asset Management", included: true },
      { name: "User Licenses", included: true, value: "3" },
      { name: "Maximum concurrent image generations", included: true, value: "1" },
      { name: "Maximum concurrent video generations", included: true, value: "1" },
      { name: "Project Management Tools", included: false },
      { name: "API Integration", included: false },
      { name: "Cloud Storage & Sharing", included: true },
      { name: "Dedicated Account Manager", included: false },
      { name: "Managed Design Services", included: false },
    ]
  },
  {
    title: "Creator",
    plan_type: 'subscription',
    title_plus: "Creator",
    subtitle: "For content creators",
    identifier: 'creator_ai',
    description:
      "180 credits a month. Up to 36 images or 4 videos.",
    price: 20,
    priceMonthly: 25,
    priceAnnual: 240,
    annualPeriod: "/month",
    monthlyPeriod: "Billed annually",
    monthlyPlusPeriod: "Billed monthly",
    buttonText: "Get Creator",
    buttonLink: "https://app.all3d.ai/register",
    discount: "20% discount on annual billing",
    discount_monthly: "",
    featuresHeading: "Includes",
    features: [
      "180 Monthly Credits",
      "Up to 36 Images (5 credits ea.)",
      "Up to 4 Videos (45 credits ea.)",
      "Commercial Usage Rights",
      "Full AI Edit Suite Access",
      "6 User Licenses",
    ],
    monthly_features: [
      "180 Monthly Credits",
      "Up to 36 Images (5 credits ea.)",
      "Up to 4 Videos (45 credits ea.)",
      "Commercial Usage Rights",
      "Full AI Edit Suite Access",
      "6 User Licenses",
    ],
    plus_features: [
      "Magic erase & resize",
      "Replace items & color correction",
      "Texture transfer (logos/small items)",
      "Upload inspiration & props",
      "Review gallery",
    ],
    get_more_toggle: true,
    get_more_text: "5 credits per image, 45 credits per video. All 2,160 credits available immediately.",
    get_more_text_monthly: "5 credits per image, 45 credits per video. 180 credits available monthly.",
    package_type: "Creator",
    plan_name: "creator_ai",
    plan_plus_name: "creator_ai",
    annual_plan_name: "annual_creator",
    credits_details: <span>Your purchase includes <b>180 credits</b> each month, redeemable at <b>5 credits per image</b> or <b>45 credits per video</b>. Unused credits roll over up to 3 months before expiring.</span>,
    annual_credits_details: <span>Your purchase includes all <b>2,160 credits</b> upfront, redeemable at <b>5 credits per image</b> or <b>45 credits per video</b>. Unused credits expire 1 year from the subscription start date. No rollovers.</span>,
    feature_table: [
      { name: "Monthly Credits", value: "180" },
      { name: "Images (5 credits ea.)", value: "Up to 36" },
      { name: "Videos (45 credits ea.)", value: "Up to 4" },
      { name: "User Licenses", value: "6" },
      { name: "Max Concurrent Image Generations", value: "1" },
      { name: "Max Concurrent Video Generations", value: "1" },
    ],
    advanced_feature_table: [
      { name: "Magic Erase & Resize", included: true },
      { name: "Replace Items & Color Correction", included: true },
      { name: "Texture Transfer (Logos/Small Items)", included: true },
      { name: "Product Silos & 3D CGI Images", included: false },
      { name: "Upload Inspiration & Props", included: true },
      { name: "Bulk Uploads", included: false },
      { name: "Brand Guidelines Support", included: false },
      { name: "Review Gallery (Quality Management)", included: true },
      { name: "Asset Management", included: true },
      { name: "User Licenses", included: true, value: "6" },
      { name: "Maximum concurrent image generations", included: true, value: "1" },
      { name: "Maximum concurrent video generations", included: true, value: "1" },
      { name: "Project Management Tools", included: false },
      { name: "API Integration", included: false },
      { name: "Cloud Storage & Sharing", included: true },
      { name: "Dedicated Account Manager", included: false },
      { name: "Managed Design Services", included: false },
    ]
  },
  {
    title: "Studio",
    plan_type: 'subscription',
    title_plus: "Studio",
    subtitle: "For growing teams",
    description:
      "450 credits a month. Up to 90 images or 10 videos.",
    identifier: 'studio_ai',
    alert: "Popular",
    price: 50,
    priceMonthly: 63,
    priceAnnual: 605,
    annualPeriod: "/month",
    monthlyPeriod: "Billed annually",
    monthlyPlusPeriod: "Billed monthly",
    buttonText: "Get Studio",
    buttonLink: "https://app.all3d.ai/register",
    discount: "20% discount on annual billing",
    discount_monthly: "",
    features: [
      "450 Monthly Credits",
      "Up to 90 Images (5 credits ea.)",
      "Up to 10 Videos (45 credits ea.)",
      "Bulk Processing Tools",
      "Brand Guidelines Support",
      "3x Concurrent Generations",
      "Unlimited User Licenses",
    ],
    monthly_features: [
      "450 Monthly Credits",
      "Up to 90 Images (5 credits ea.)",
      "Up to 10 Videos (45 credits ea.)",
      "Bulk Processing Tools",
      "Brand Guidelines Support",
      "3x Concurrent Generations",
      "Unlimited User Licenses",
    ],
    plus_features: [
      "Magic erase & resize",
      "Replace items & color correction",
      "Texture transfer (logos/small items)",
      "Upload inspiration & props",
      "Bulk uploads",
      "Brand guidelines support",
      "Review gallery",
    ],
    get_more_toggle: true,
    get_more_text: "5 credits per image, 45 credits per video. All 5,400 credits available immediately.",
    get_more_text_monthly: "5 credits per image, 45 credits per video. 450 credits available monthly.",
    package_type: "Studio",
    plan_name: "studio_ai",
    plan_plus_name: "studio_ai",
    annual_plan_name: "annual_studio",
    credits_details: <span>Your purchase includes <b>450 credits</b> each month, redeemable at <b>5 credits per image</b> or <b>45 credits per video</b>. Unused credits roll over up to 3 months before expiring.</span>,
    annual_credits_details: <span>Your purchase includes all <b>5,400 credits</b> upfront, redeemable at <b>5 credits per image</b> or <b>45 credits per video</b>. Unused credits expire 1 year from the subscription start date. No rollovers.</span>,
    feature_table: [
      { name: "Monthly Credits", value: "450" },
      { name: "Images (5 credits ea.)", value: "Up to 90" },
      { name: "Videos (45 credits ea.)", value: "Up to 10" },
      { name: "User Licenses", value: "Unlimited" },
      { name: "Max Concurrent Image Generations", value: "3" },
      { name: "Max Concurrent Video Generations", value: "2" },
    ],
    advanced_feature_table: [
      { name: "Magic Erase & Resize", included: true },
      { name: "Replace Items & Color Correction", included: true },
      { name: "Texture Transfer (Logos/Small Items)", included: true },
      { name: "Product Silos & 3D CGI Images", included: false },
      { name: "Upload Inspiration & Props", included: true },
      { name: "Bulk Uploads", included: true },
      { name: "Brand Guidelines Support", toolTip: "All generations and edits based on brand aesthetic, lighting, room types, props and camera angles", included: true },
      { name: "Review Gallery (Quality Management)", included: true },
      { name: "Asset Management", included: true },
      { name: "User Licenses", included: true, value: "Unlimited" },
      { name: "Maximum concurrent image generations", included: true, value: "3" },
      { name: "Maximum concurrent video generations", included: true, value: "2" },
      { name: "Project Management Tools", included: false },
      { name: "API Integration", included: false },
      { name: "Cloud Storage & Sharing", included: true },
      { name: "Dedicated Account Manager", included: false },
      { name: "Managed Design Services", included: false },
    ]
  },
  {
    title: "Business",
    plan_type: 'subscription',
    title_plus: "Business",
    subtitle: "For scaling businesses",
    identifier: 'business_ai',
    description:
      "1,000+ scalable credits a month.",
    price: 116,
    priceMonthly: 140,
    priceAnnual: 1344,
    annualPeriod: "/month",
    monthlyPeriod: "Billed annually",
    monthlyPlusPeriod: "Billed monthly",
    buttonText: "Get Scale",
    buttonLink: "https://app.all3d.ai/register",
    discount: "20% discount on annual billing",
    discount_monthly: "",
    features: [
      "1,000+ Scalable Credits",
      "Up to 200+ Images (5 credits ea.)",
      "Up to 22+ Videos (45 credits ea.)",
      "Full API Access",
      "Review Gallery & QA Tools",
      "10x Concurrent Generations",
      "Priority Support",
    ],
    monthly_features: [
      "1,000+ Scalable Credits",
      "Up to 200+ Images (5 credits ea.)",
      "Up to 22+ Videos (45 credits ea.)",
      "Full API Access",
      "Review Gallery & QA Tools",
      "10x Concurrent Generations",
      "Priority Support",
    ],
    plus_features: [
      "Magic erase & resize",
      "Replace items & color correction",
      "Texture transfer (logos/small items)",
      "Upload inspiration & props",
      "Bulk uploads",
      "Brand guidelines support",
      "Review gallery",
      "API integration",
    ],
    get_more_toggle: true,
    get_more_text: "5 credits per image, 45 credits per video. All 12,000 credits available immediately.",
    get_more_text_monthly: "5 credits per image, 45 credits per video. 1,000 credits available monthly.",
    package_type: "Business",
    plan_name: "business_ai",
    plan_plus_name: "business_ai",
    annual_plan_name: "annual_business_ai",
    credits_details: <span>Your purchase includes <b>1,000 credits</b> each month, redeemable at <b>5 credits per image</b> or <b>45 credits per video</b>. Unused credits roll over up to 3 months before expiring.</span>,
    annual_credits_details: <span>Your purchase includes all <b>12,000 credits</b> upfront, redeemable at <b>5 credits per image</b> or <b>45 credits per video</b>. Unused credits expire 1 year from the subscription start date. No rollovers.</span>,
    tiers: [
      {
        multiplier: 1,
        credits: 1000,
        price: 140,
        annualPriceTotal: 1344,
        features: [
          "Up to 200 Images",
          "Up to 22 Videos",
          "Unlimited Users",
          "API Access"
        ]
      },
      {
        multiplier: 2,
        credits: 2000,
        price: 280,
        annualPriceTotal: 2688,
        features: [
          "Up to 400 Images",
          "Up to 44 Videos",
          "Unlimited Users",
          "API Access"
        ]
      },
      {
        multiplier: 4,
        credits: 4000,
        price: 560,
        annualPriceTotal: 5376,
        features: [
          "Up to 800 Images",
          "Up to 88 Videos",
          "Unlimited Users",
          "API Access"
        ]
      },
      {
        multiplier: 8,
        credits: 8000,
        price: 1120,
        annualPriceTotal: 10752,
        features: [
          "Up to 1600 Images",
          "Up to 176 Videos",
          "Unlimited Users",
          "API Access"
        ]
      },
      {
        multiplier: 16,
        credits: 16000,
        price: 2240,
        annualPriceTotal: 21504,
        features: [
          "Up to 3200 Images",
          "Up to 352 Videos",
          "Unlimited Users",
          "API Access"
        ]
      },
      {
        multiplier: 32,
        credits: 32000,
        price: 4480,
        annualPriceTotal: 43008,
        features: [
          "Up to 6400 Images",
          "Up to 704 Videos",
          "Unlimited Users",
          "API Access"
        ]
      }
    ],
    feature_table: [
      { name: "Monthly Credits", value: "1,000+" },
      { name: "Images (5 credits ea.)", value: "Up to 200+" },
      { name: "Videos (45 credits ea.)", value: "Up to 22+" },
      { name: "User Licenses", value: "Unlimited" },
      { name: "Max Concurrent Image Generations", value: "10" },
      { name: "Max Concurrent Video Generations", value: "5" },
    ],
    advanced_feature_table: [
      { name: "Magic Erase & Resize", included: true },
      { name: "Replace Items & Color Correction", included: true },
      { name: "Texture Transfer (Logos/Small Items)", included: true },
      { name: "Product Silos & 3D CGI Images", included: false },
      { name: "Upload Inspiration & Props", included: true },
      { name: "Bulk Uploads", included: true },
      { name: "Brand Guidelines Support", toolTip: "All generations and edits based on brand aesthetic, lighting, room types, props and camera angles", included: true },
      { name: "Review Gallery (Quality Management)", included: true },
      { name: "Asset Management", included: true },
      { name: "User Licenses", included: true, value: "Unlimited" },
      { name: "Maximum concurrent image generations", included: true, value: "10" },
      { name: "Maximum concurrent video generations", included: true, value: "5" },
      { name: "Project Management Tools", included: false },
      { name: "API Integration", included: true },
      { name: "Cloud Storage & Sharing", included: true },
      { name: "Dedicated Account Manager", included: false },
      { name: "Managed Design Services", included: false },
    ]
  },
  {
    title: "Enterprise",
    plan_type: 'subscription',
    subtitle: "For large teams",
    description:
      "Custom plan with 3D/AR",
    price: "Let's talk",
    priceAnnual: "",
    priceMonthly: "",
    annualPeriod: "",
    monthlyPeriod: "Schedule a time to discuss",
    monthlyPlusPeriod: "Schedule a time to discuss",
    buttonText: "Contact Sales",
    buttonLink: "https://all3d.ai/contact-us",
    monthly_features: [
      "Photorealistic 3D Models",
      "AR 'View in Room' Scenes",
      "3D Product Configurator",
      "Dedicated Account Manager",
      "Managed Design Services",
    ],
    features: [
      "Photorealistic 3D Models",
      "AR 'View in Room' Scenes",
      "3D Product Configurator",
      "Dedicated Account Manager",
      "Managed Design Services",
    ],

    plus_features: [
      "Photorealistic 3D models",
      "AR view in room",
      "Product silo images",
      "3D CGI images",
      "Custom scenes",
      "API integration",
      "3D configurator",
      "Project management",
      "Team collaboration"
    ],

    get_more_toggle: false,
    get_more_text: <a href="https://all3d.ai/contact-us">Contact us</a>,
    package_type: "Enterprise",
    plan_name: "enterprise",
    plan_plus_name: "enterprise",
    annual_plan_name: "enterprise",
    credits_details: "",
    annual_credits_details: "",
    discount: "",
    discount_monthly: "",
    feature_table: [
      { name: "Credits", value: "Custom" },
      { name: "Images", value: "Custom" },
      { name: "Videos", value: "Custom" },
      { name: "User Licenses", value: "Unlimited" },
      { name: "Max Concurrent Image Generations", value: "Custom" },
      { name: "Max Concurrent Video Generations", value: "Custom" },
    ],
    advanced_feature_table: [
      { name: "Magic Erase & Resize", included: true },
      { name: "Replace Items & Color Correction", included: true },
      { name: "Texture Transfer (Logos/Small Items)", included: true },
      { name: "Product Silos & 3D CGI Images", included: true },
      { name: "Upload Inspiration & Props", included: true },
      { name: "Bulk Uploads", included: true },
      { name: "Brand Guidelines Support", toolTip: "All generations and edits based on brand aesthetic, lighting, room types, props and camera angles", included: true },
      { name: "Review Gallery (Quality Management)", included: true },
      { name: "Asset Management", included: true },
      { name: "User Licenses", included: true, value: "Unlimited" },
      { name: "Maximum concurrent image generations", included: true, value: "Custom" },
      { name: "Maximum concurrent video generations", included: true, value: "Custom" },
      { name: "Project Management Tools", included: true },
      { name: "API Integration", included: true },
      { name: "Cloud Storage & Sharing", included: true },
      { name: "Dedicated Account Manager", included: true },
      { name: "Managed Design Services", included: true },

      { name: "Photorealistic 3D models", included: true, is3DFeature: true },
      { name: "AR view in room", included: true, is3DFeature: true },
      { name: "Product silo images", included: true, is3DFeature: true },
      { name: "3D CGI images", included: true, is3DFeature: true },
      { name: "3D Custom scenes", included: true, is3DFeature: true },
      { name: "3D configurator", included: true, is3DFeature: true },
      { name: "Project management", included: true, is3DFeature: true },
    ]
  },
];

export const bundles = [
  {
    title: "Basic Bundle",
    plan_type: 'bundle',
    identifier: 'basic_ai',
    subtitle: "For self-serve users",
    description:
      "Flexible & easy-to-manage.",
    price: 49,
    buttonText: "Buy",
    image_length: '5 image minimum',
    min_quantity: 5,
    credit_multiplier: 5,
    features: [
      "Custom credits (25 minimum)",
      "Up to 5 Images (5 credits ea.)",
      "Up to 1 Video (45 credits ea.)",
      "3 User Licenses",
      "Asset management",
      "Sharing & cloud storage",
    ],
    plus_features: [
      "Magic erase & resize",
      "Replace items & color correction",
      "Upload inspiration & props",
    ],
    package_type: 'AI Creator',
    name: 'basic_ai',
    credits_details: <span>Your purchase includes <b>credits</b>, redeemable at <b>5 credits per image</b> or <b>45 credits per video</b>. Unused credits expire 1 year from the purchase date. No rollovers.</span>,
    feature_table: [
      { name: "Credits", value: "Custom" },
      { name: "Images (5 credits ea.)", value: "Custom" },
      { name: "Videos (45 credits ea.)", value: "Custom" },
      { name: "User Licenses", value: "3" },
    ],
    advanced_feature_table: [
      { name: "Magic Erase & Resize", included: true },
      { name: "Replace Items & Color Correction", included: true },
      { name: "Texture Transfer (Logos/Small Items)", included: false },
      { name: "Product Silos & 3D CGI Images", included: false },
      { name: "Upload Inspiration & Props", included: true },
      { name: "Bulk Uploads", included: false },
      { name: "Review Gallery (Quality Management)", included: true },
      { name: "Asset Management", included: true },
      { name: "Maximum concurrent image generations", included: true, value: 3 },
      { name: "Maximum concurrent video generations", included: true, value: 1 },
      { name: "Cloud Storage & Sharing", included: true },
      { name: "Dedicated Account Manager", included: false },
      { name: "Managed Design Services", included: false },
    ]
  },
  {
    title: "Studio Bundle",
    plan_type: 'bundle',
    identifier: 'studio_ai',
    alert: "Popular",
    subtitle: "For low-touch users",
    description: "Designer-guided & managed",
    price: 110,
    buttonText: "Buy",
    image_length: '45 image minimum',
    min_quantity: 45,
    credit_multiplier: 5,
    features: [
      "Custom credits (225 minimum)",
      "Up to 45 Images (5 credits ea.)",
      "Up to 5 Videos (45 credits ea.)",
      "Unlimited User Licenses",
      "Asset management",
      "Sharing & cloud storage",
      "Brand guidelines support",
      "Managed design services",
      "Dedicated support",
    ],
    plus_features: [
      "Magic erase & resize",
      "Replace items & color correction",
      "Texture transfer (logos/small items)",
      "Upload inspiration & props",
      "Bulk uploads",
    ],
    package_type: 'PDP Basic',
    name: 'studio_ai',
    credits_details: <span>Your purchase includes <b>credits</b>, redeemable at <b>5 credits per image</b> or <b>45 credits per video</b>. Unused credits expire 1 year from the purchase date. No rollovers.</span>,
    feature_table: [
      { name: "Credits", value: "Custom" },
      { name: "Images (5 credits ea.)", value: "Custom" },
      { name: "Videos (45 credits ea.)", value: "Custom" },
      { name: "User Licenses", value: "Unlimited" },
    ],
    advanced_feature_table: [
      { name: "Magic Erase & Resize", included: true },
      { name: "Replace Items & Color Correction", included: true },
      { name: "Texture Transfer (Logos/Small Items)", included: true },
      { name: "Product Silos & 3D CGI Images", included: false },
      { name: "Upload Inspiration & Props", included: true },
      { name: "Bulk Uploads", included: true },
      { name: "Brand Guidelines Support", toolTip: "All generations and edits based on brand aesthetic, lighting, room types, props and camera angles", included: true },
      { name: "Review Gallery (Quality Management)", included: true },
      { name: "Asset Management", included: true },
      { name: "Maximum concurrent image generations", included: true, value: 6 },
      { name: "Maximum concurrent video generations", included: true, value: 3 },
      { name: "Cloud Storage & Sharing", included: true },
      { name: "Managed design services", included: true },
      { name: "Dedicated support", included: true },
      { name: "Dedicated Account Manager", included: false },
    ]
  },
  {
    title: "Enterprise",
    plan_type: 'bundle',
    subtitle: "For large teams",
    description:
      "Custom plan with 3D & AR",
    price: 0,
    buttonText: "Schedule a demo",
    image_length: 'Schedule a time to discuss',
    min_quantity: 1,
    features: [
      "Custom credits",
      "Custom images & videos",
      "Multiple user licenses",
      "Asset management",
      "Sharing & cloud storage",
      "Managed design services",
      "Dedicated support",
      "Account manager",
    ],
    plus_features: [
      "Photorealistic 3D models",
      "AR view in room",
      "Product silo images",
      "3D CGI images",
      "Custom scenes",
      "API integration",
      "3D configurator",
      "Project management",
      "Team collaboration",
    ],
    package_type: 'PDP Pro',
    name: 'pdp_pro',
    credits_details: "",
    get_more_text: <a href="https://all3d.ai/contact-us">Contact us</a>,
    feature_table: [
      { name: "Credits", value: "Custom" },
      { name: "Images", value: "Custom" },
      { name: "Videos", value: "Custom" },
      { name: "User Licenses", value: "Multiple" },
    ],
    advanced_feature_table: [
      { name: "Magic Erase & Resize", included: true },
      { name: "Replace Items & Color Correction", included: true },
      { name: "Texture Transfer (Logos/Small Items)", included: true },
      { name: "Product Silos & 3D CGI Images", included: true },
      { name: "Upload Inspiration & Props", included: true },
      { name: "Bulk Uploads", included: true },
      { name: "Brand Guidelines Support", toolTip: "All generations and edits based on brand aesthetic, lighting, room types, props and camera angles", included: true },
      { name: "Review Gallery (Quality Management)", included: true },
      { name: "Asset Management", included: true },
      { name: "Maximum concurrent image generations", included: true, value: "Unlimited" },
      { name: "Maximum concurrent video generations", included: true, value: "Unlimited" },
      { name: "Cloud Storage & Sharing", included: true },
      { name: "API Integration", included: true },
      { name: "Managed design services", included: true },
      { name: "Dedicated support", included: true },
      { name: "Account manager", included: true },

      { name: "Photorealistic 3D models", included: true, is3DFeature: true },
      { name: "AR view in room", included: true, is3DFeature: true },
      { name: "Product silo images", included: true, is3DFeature: true },
      { name: "3D CGI images", included: true, is3DFeature: true },
      { name: "3D Custom scenes", included: true, is3DFeature: true },
      { name: "3D configurator", included: true, is3DFeature: true },
      { name: "Project management", included: true, is3DFeature: true },
    ]
  },
];

export const nextSubscription = {
  'Free Trial': {
    'display_name': 'Discovery',
    'name': 'Discovery',
    'monthly_link': 'https://app.all3d.ai/register',
    'annual_link': '',
    'plan_name': 'free_trial_ai',
  },
  'Discovery': {
    'display_name': 'Creator',
    'name': 'Creator',
    'monthly_link': '',
    'annual_link': '',
    'plan_name': 'creator_ai',
  },
  'Creator': {
    'display_name': 'Studio',
    'name': 'Studio',
    'monthly_link': '',
    'annual_link': '',
    'plan_name': 'studio_ai',
  },
  'Studio': {
    'display_name': 'Business',
    'name': 'Business',
    'monthly_link': '',
    'annual_link': '',
    'plan_name': 'business_ai',
  },
  'Business': {
    'display_name': 'Enterprise',
    'name': 'Enterprise',
    'monthly_link': '',
    'annual_link': '',
    'plan_name': 'enterprise',
  }
}

export const nextBundle = {
  'Free Trial': {
    'name': 'Basic Bundle',
    'link': 'https://app.all3d.ai/register',
  },
  'Basic Bundle': {
    'name': 'Studio Bundle',
    'link': '',
  },
  'Studio Bundle': {
    'name': 'Enterprise',
    'link': '',
  },
}


export const users = [
  {
    icon: "/amazon_icon.svg",
    title: "Amazon Sellers",
    description:
      "Get all your listing photography and AR view in room in one place.",
  },
  {
    icon: "/basket.svg",
    title: "Online DTC Brands",
    description:
      "Easily create product and lifestyle photos to use on your ecommerce site and marketing on social media channels.",
  },
  {
    icon: "/solar_shop.svg",
    title: "Large Retailers",
    description:
      "Get all your manufacturer models in one place to create multi-vendor lifestyle content quickly and easily.",
  },
  {
    icon: "/clarity_factory.svg",
    title: "Manufacturers",
    description:
      "Create prototypes of products, show your products in beautiful spaces and generate all your virtual content in one place.",
  },
  {
    icon: "/pencil_scale.svg",
    title: "Interior Designers",
    description:
      "Create photorealistic images, 360s and 3D tours of designs for your clients. Quickly create engaging social media content.",
  },
  {
    icon: "/real_estate.svg",
    title: "Real Estate Agencies",
    description:
      "Create 3D room tours and photorealistic staging images of high-profile listings to reach more potential clients.",
  },
];

export const brands = [
  { name: "Anthony", path: "/brands/nathan_anthony.svg" },
  { name: "Novogratz", path: "/brands/novogratz.svg" },
  { name: "Skyline Furniture", path: "/brands/skyline.svg" },
  { name: "Safavieh", path: "/brands/safavieh.svg" },
  { name: "RH", path: "/brands/rh_logo.svg" },
  { name: "Walmart", path: "/brands/wallmart.svg" },
  { name: "The Home Depot", path: "/brands/the_home_depot.svg" },
  { name: "Uttermost", path: "/brands/uttermost.svg" },
  { name: "Basset", path: "/brands/basset.svg" },
  { name: "hooker", path: "/brands/hooker.svg" },
];

export const features = [
  {
    title: "3D/AR Model Creation",
    description:
      "It all starts with creating accurate 3D models of your products and variants.",
    image: "/features/feature_chair.png",
    featuresList: [
      {
        title: "3D product models",
        description:
          "High-quality, accurate 3D models of your products we create or you can upload",
      },
      {
        title: "Product variants",
        description:
          "Multiple variants or SKUs of your product in different colors, materials, etc.",
      },
      {
        title: "AR product models",
        description:
          "Realistic AR product models for your PDP's view in room feature",
      },
      {
        title: "3D space models",
        description:
          "Single or connected rooms to create lifestyles, 360 room spins, or 3D tours",
      },
    ],
  },
  {
    title: "Photorealistic Images & Assets",
    description:
      "Manage all your assets in one place – from silos, 360 spins, and AR for your PDP to imagery and lifestyles for marketing and social.",
    image: "/features/cycle.png",
    featuresList: [
      {
        title: "Silo & dimensional images",
        description:
          "Clear product shots in multiple angles on a white or gray background, with or without dimensions",
      },
      {
        title: "Lifestyle images",
        description:
          "Photorealistic images of your product set in a room scene helping to show scale and use",
      },
      {
        title: "360 product spins",
        description:
          "A 360 animated spin of your product showcasing all angles",
      },
      {
        title: "AR view in room",
        description: "Uses an AR model to allow the view in room feature",
      },
    ],
  },
  {
    title: "Scene Creator Tool",
    description:
      "Scene Creator places your product into a styled vignette or room scene to create lifestyle images showing your product's scale and use.",
    image: "/features/scene_creator.png",
    featuresList: [
      {
        title: "Lifestyle images",
        description:
          "Photorealistic images of your product set in a room scene helping to show scale and use",
      },
      {
        title: "3D tour of spaces",
        description:
          "A 360 spin of a room scene showcasing your product or designed space",
      },
      {
        title: "Design services available",
        description:
          "Work with a designer to style custom scenes for your product's lifestyle images",
        isAdd: true,
      },
      {
        title: "Training available",
        description:
          "Get your team up to speed faster using our platform with a training session",
        isAdd: true,
      },
    ],
  },
  {
    title: "Free ALL3D Store Models",
    description:
      "You'll have free access to the ALL3D store to use a wide variety of 3D models including products, props, spaces, and scene templates.",
    image: "/features/store_models.png",
    featuresList: [
      {
        title: "Free product & prop models",
        description:
          "Browse a variety of products and props to style with your product for a lifestyle image",
      },
      {
        title: "Free spaces",
        description:
          "Place your products and other props into a space to create a unique lifestyle environment",
      },
      {
        title: "Free styled scene templates",
        description:
          "Choose from a variety of styled scenes to place your product for a quick lifestyle image",
      },
    ],
  },
  {
    title: "Sharing & Cloud Storage",
    description:
      "With your asset library in the cloud, you can easily share and collaborate with your team on your 3D models, scenes, and images.",
    image: "/features/cloud_storage.png",
    featuresList: [
      {
        title: "Share and collaborate",
        description:
          "Ability to share and collaborate with your team on models and designs",
      },
      {
        title: "Cloud storage",
        description:
          "Unlimited cloud storage for your model and asset libraries",
      },
    ],
  },
];

export const faqs = [
  {
    question: "How does the free trial work?",
    answer:
      "Our free trial gives you full access to all features for 14 days. No credit card required.",
  },
  {
    question: "What features can I access once I have an ALL3D account?",
    answer:
      "With an ALL3D account, you get access to our complete suite of 3D modeling tools, rendering capabilities, and collaboration features.",
  },
  {
    question: "How do subscriptions work?",
    answer:
      "Subscriptions are billed monthly or annually. Choose the plan that best fits your needs and scale up or down as needed.",
  },
  {
    question:
      "Are there additional costs associated with a subscription? What if I need less or more each month?",
    answer:
      "Your subscription covers all core features. You can upgrade or downgrade your plan at any time to match your usage needs.",
  },
  {
    question: "How does an enterprise account work?",
    answer:
      "Enterprise accounts offer custom solutions, dedicated support, and advanced features for large organizations.",
  },
  {
    question: "What if I need something not included in a bundle?",
    answer:
      "Contact our sales team to discuss custom solutions and additional features not included in standard bundles.",
  },
  {
    question: "Is there training available?",
    answer:
      "Yes, we offer comprehensive training resources, including video tutorials, documentation, and live webinars.",
  },
  {
    question: "What is the cancellation or return policy?",
    answer:
      "You can cancel your subscription at any time. Refunds are processed according to our terms of service.",
  },
];

export const PLAN_DETAIL_MODALS = [
  {
    'title': 'ALL3D Discovery Plan',
    'features': [
      {
        'image': '/PricingModal/AI-Lifestyle1.png',
        'title': '25 Monthly Credits',
        'subtext': 'Up to 5 AI images per month (5 credits each)'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': 'AI Creative Suite',
        'subtext': 'Magic erase, resize, replace items & color correction'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
      {
        'image': '/PricingModal/license.png',
        'title': '3 User Licenses',
        'subtext': 'User seats available for your platform usage'
      },
    ],
    'button_text': 'Start Free Trial'
  },
  {
    'title': 'ALL3D Creator Subscription',
    'features': [
      {
        'image': '/PricingModal/AI-Lifestyle1.png',
        'title': '180 Monthly Credits',
        'subtext': 'Up to 36 images (5 credits ea.) or 4 videos (45 credits ea.)'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': 'Full AI Edit Suite',
        'subtext': 'Magic erase, resize, replace items, color correction & texture transfer'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Commercial Usage Rights',
        'subtext': 'Full rights to use generated content commercially'
      },
      {
        'image': '/PricingModal/license.png',
        'title': '6 User Licenses',
        'subtext': 'User seats available for your platform usage'
      },
    ],
    'button_text': 'Get Creator'
  },
  {
    'title': 'ALL3D Studio Subscription',
    'features': [
      {
        'image': '/PricingModal/AI-Lifestyle1.png',
        'title': '450 Monthly Credits',
        'subtext': 'Up to 90 images (5 credits ea.) or 10 videos (45 credits ea.)'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': 'Full AI Edit Suite + Bulk Tools',
        'subtext': 'All editing features plus bulk processing capabilities'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Brand Guidelines Support',
        'subtext': 'Generations based on your brand aesthetic, lighting & styling'
      },
      {
        'image': '/PricingModal/license.png',
        'title': 'Unlimited User Licenses',
        'subtext': '3x concurrent image generations, 2x concurrent video generations'
      },
    ],
    'button_text': 'Get Studio'
  },
  {
    'title': 'ALL3D Scale Subscription',
    'features': [
      {
        'image': '/PricingModal/AI-Lifestyle1.png',
        'title': '1,000+ Scalable Credits',
        'subtext': 'Up to 200+ images (5 credits ea.) or 22+ videos (45 credits ea.)'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': 'Full API Access',
        'subtext': 'Integrate ALL3D capabilities directly into your workflow'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Review Gallery & QA Tools',
        'subtext': 'Quality management and review tools for your content'
      },
      {
        'image': '/PricingModal/license.png',
        'title': '10x Concurrent Generations',
        'subtext': 'Unlimited users with priority support'
      },
    ],
    'button_text': 'Get Scale'
  },
  {
    'title': 'ALL3D Enterprise Subscription',
    'features': [
      {
        'image': '/PricingModal/photorealisticmodels.png',
        'title': 'Photorealistic 3D Models',
        'subtext': 'High-quality product models to use in ecommerce listings'
      },
      {
        'image': '/PricingModal/AR1.png',
        'title': "AR 'View in Room' Scenes",
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/configurator.png',
        'title': '3D Product Configurator',
        'subtext': 'Interactive 3D configurator for your products'
      },
      {
        'image': '/PricingModal/collaboration.png',
        'title': 'Dedicated Account Manager',
        'subtext': 'Personal account management and support'
      },
    ],
    'extra_features': [
      {
        'image': '/PricingModal/small_pic.png',
        'title': 'Project & Asset Management',
      },
      {
        'image': '/PricingModal/managed.png',
        'title': 'Managed Design Services',
      },
      {
        'image': '/PricingModal/chat.png',
        'title': 'Account Manager',
      },
      {
        'image': '/PricingModal/support.png',
        'title': 'Dedicated Support',
      },
      {
        'image': '/PricingModal/cloud_small.png',
        'title': 'Sharing & Cloud Storage',
      },
      {
        'image': '/PricingModal/license_small.png',
        'title': 'Multiple user licenses',
      },
    ],
    'button_text': 'Contact Sales'
  }
]


export const BUNDLE_DETAIL_MODALS = [
  {
    'title': 'AI Creator Package',
    'features': [
      {
        'image': '/PricingModal/AI-Lifestyle1.png',
        'title': 'AI Image Credits',
        'subtext': 'Generate images at 5 credits per image'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': 'AI Edit Suite',
        'subtext': 'Magic erase, resize, replace items & color correction'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
    ],
    'button_text': 'Buy AI Creator',
  },
  {
    'title': 'PDP Basic',
    'features': [
      {
        'image': '/PricingModal/AI-Lifestyle1.png',
        'title': 'AI Image & Video Credits',
        'subtext': '5 credits per image, 45 credits per video'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': 'Full AI Edit Suite',
        'subtext': 'All editing features including texture transfer & bulk uploads'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
    ],
    'button_text': 'Buy PDP Basic',
  },
  {
    'title': 'PDP Pro',
    'features': [
      {
        'image': '/PricingModal/AI-Lifestyle1.png',
        'title': 'AI Image & Video Credits',
        'subtext': '5 credits per image, 45 credits per video'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': 'Full AI Edit Suite + API',
        'subtext': 'All editing features plus API integration'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Managed Design Services',
        'subtext': 'Designer-guided content creation with dedicated support'
      },
    ],
    'button_text': 'Buy PDP Pro',
  }
]

export const VIEW_MODAL_DICT = {
  'Free': 'ALL3D Discovery Plan',
  'Discovery': 'ALL3D Discovery Plan',
  'Creator': 'ALL3D Creator Subscription',
  'Studio': 'ALL3D Studio Subscription',
  'Scale': 'ALL3D Scale Subscription',
  'Enterprise': 'ALL3D Enterprise Subscription',
  'AI Creator': 'AI Creator Package',
  'PDP Basic': 'PDP Basic',
  'PDP Pro': 'PDP Pro'
}

export const PLANS_NAMES_MAPPING = {
  'free_trial': 'Free Trial',
  'free_trial_ai': 'Discovery',
  'creator_ai': 'Creator',
  'studio_ai': 'Studio',
  'scale_ai': 'Scale',
  'ai-creator': 'AI Creator',
  'pdp_basic': 'PDP Basic',
  'pdp_pro': 'PDP Pro'
}
